import { postRequest, postRequestNoLoading } from 'utils/http';
import { BACKEND_API } from 'global/environment';
import { cui } from 'components';
import { CommonService } from './CommonService';

const baseURL = BACKEND_API;

function pad2(n) {
  return n < 10 ? '0' + n : n
};

function decryptAES(data) {
  return CommonService.decryptAES(data);
}

const getDuration = function (second) {
  if (second < 3600) {
    let m = parseInt(second / 60);
    const s = second % 60;
    return `${pad2(m)}:${pad2(s)}`;
  } else {
    let h = parseInt(second / 3600);
    let remain = second % 3600;
    let m = parseInt(remain / 60);
    const s = remain % 60;
    return `${pad2(h)}${pad2(m)}:${pad2(s)}`;
  }
}

const transformPhoneNumber = function (response) {
  cui.each(response.result, item => {
    if (cui.has(item, 'B_SUBS') && item.B_SUBS.slice(0, 4) === '8400') {
      item.convertedPhone = `0${item.B_SUBS.slice(5, item.B_SUBS.length)}`;
    }
    if (item.CALL_TYPE === 'Voice') {
      item.convertedDuration = getDuration(item.DURATION);
    }
  });
  return response;
};

const transformContract = function (response) {
  if (response.error_code === '0') {
    const newList = response.result.map(item => {
      item.ACCOUNT = decryptAES(item.ACCOUNT);
      return {
        ...item,
        value: item.ACCOUNT,
        text: item.ACCOUNT,
        PRODUCT_LINE: decryptAES(item.PRODUCT_LINE),
        CONTACT: decryptAES(item.CONTACT),
      }
    });
    response.transformList = newList;
  }
  return response;
};

const transformEkycToken = function (res) {
  if (res.error_code === '0') {
    res.data = {
      AUTHORIZION: decryptAES(res.access_token),
      TOKEN_KEY: decryptAES(res.token_tokenKey),
      TOKEN_ID: decryptAES(res.token_id)
    }
  }
  return res;
};

const transformCCBS = function (response) {
  const newList = response.result.map(item => {
    return {
      value: item.PACKAGE_ID,
      text: item.NAME_PKG,
    }
  });
  response.transformList = newList;
  return response;
};

const transformStaffList = function (response) {
  const newList = response.result.map(item => {
    item.childs.forEach(child => {
      child.value = child.id;
      child.text = child.name;
    });
    return {
      value: item.id,
      text: item.name,
      childs: item.childs
    }
  });
  response.transformList = newList;
  return response;
};

const transformListServiceActived = function (response) {
  if (response.error_code === 0) {
    const { result } = response;
    let newArr = [];
    for (let p in result) {
      newArr = [...newArr, ...result[p]];
    }
    const newList = newArr.map(item => {
      return item.code;
    });
    response.transformList = newList;
  }
  return response;
};


function removeParam(key, sourceURL) {
  let rtn = sourceURL.split("?")[0],
    param,
    params_arr = [],
    queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

  if (queryString !== "") {
    params_arr = queryString.split("&");
    for (let i = params_arr.length - 1; i >= 0; i--) {
      param = params_arr[i].split("=")[0];
      if (param === key) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

function getActionFromUrl(url) {
  const arr = url.split("/");
  let action = arr[arr.length - 1];
  action = action.replace(/-/g, "");
  return action;
}

const transformUrlMapping = function name(res) {
  if (res.error_code === '0') {
    const url = new URL(res.url_common);
    const channel = url.searchParams.get("channel") || '';
    const camp = url.searchParams.get("camp") || '';
    const sub_id = url.searchParams.get("sub_id") || '';

    let params = url.search;
    params = removeParam('channel', params);
    params = removeParam('camp', params);
    const convertUrl = `${url.pathname}${params}`;
    const action = getActionFromUrl(url.pathname) || '';
    res = {
      ...res,
      channel,
      camp,
      convertUrl,
      action,
      sub_id
    };
  }
  return res;
}

export const UserService = {
  login: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/authen_msisdn`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  logout: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/authen_logout`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  register: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/authen_register`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  sendOTP: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/otp_send`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  deSendOTP: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/de_send_otp`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  otpSmart: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/otp_smart`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  missPassword: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/authen_miss_password`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkOTP: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/otp_check`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getUserInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/core_customer_get_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getUrlMapping: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_url_mapping`;
    return postRequest(URL, data, {}, successCallback, failCallback, transformUrlMapping);
  },

  getAccountInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/core_mobile_ezpay_balance`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getRank: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/get_rank_vnp_plus`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getServiceActive: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_get_service_active_list`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformListServiceActived);
  },

  // get thong tin tai khoan
  getMobileInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_get_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get thong tin tai khoản thoại, sms
  getBundleRemain: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_bundle_remain_amount`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get thong tin data
  getHighBanwidth: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_data_get_high_bandwidth`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback);
  },

  // get so tien tkc, tk km
  getMobileBanlances: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_IN_balances`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getInfoCustom: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/cust_get_info_ver2`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback);
  },

  // get thong tin hop dong mytv, internet
  getContractInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/cust_get_subscribers_by_invoice2`;
    return postRequest(URL, data, {}, successCallback, failCallback, transformContract);
  },

  // lay thong tin thiet bi
  getByOptical: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_by_optical`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListWifi: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_list_wlan`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListUserConnect: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_connected_user_infor`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListUserBlock: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_block_client`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  scheduleOnOffWifi: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_on_off_wifi_schedule`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  scheduleRebootDevice: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_reboot_device_schedule`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  cancelSchedule: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_control_schedule_deletion`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  blockUserAccess: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_block_client_access`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  unblockUserAccess: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_unblock_client_access`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getRebootSchedule: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_reboot_schedule`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getWifiSchedule: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms_get_on_off_wifi_schedule`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // add sdt để quản lý tk fiber
  addPhoneManageFiber: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/fiber_add_account`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // add sdt để quản lý tk mytv
  addPhoneManageMytv: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mytv_add_account`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get otp by call
  getOtpVoice: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/otp_voice_send`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get info lịch sử nợ 
  getDebtHistory: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/cust_nonmobile_lichsu_no`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // api for wifi
  apiWifi: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/gnms`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getInternetInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/fiber_get_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getMytvInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mytv_get_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getPhoneInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/phone_get_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // api for home combo
  checkFamilyStatus: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_check_family_status`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getDataRemain: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_member_data_remain_ver2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getRemainInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/home_combo_get_remain_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  addMemberHomeCombo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_master_add_member`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  deleteMemberHomeCombo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_master_del_member`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  leaveGroupHomeCombo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_member_leave`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  shareDataMemberHomeCombo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_set_volume_for_sub`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListPackageUpgrade: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_master_list_advanced_pack`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  upgradeHomeComboPackage: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_master_upgrade_pack`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // 
  submitContractProfile: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/custservice_submit_contract_profile_1800`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get lich su giao dich
  getTransactionHistory: function (TRA_SAU, data, successCallback, failCallback) {
    const URL = `${baseURL}/${TRA_SAU ? 'mobile_post_billing_history' : 'mobile_prepaid_refill_history'}`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // get lich su su dung
  getUsageHistory: function (TRA_SAU, data, successCallback, failCallback) {
    const URL = `${baseURL}/${TRA_SAU ? 'mobile_post_hist_detail' : 'mobile_prepaid_hist_detail'}`;
    return postRequest(URL, data, {}, successCallback, failCallback, transformPhoneNumber);
  },

  // get cau hoi
  getQuestion: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_get_faq`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getMyQuestion: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_feedback_get_sent`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  makeQuestion: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_feedback_send`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkStatusFamily: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_check_subs_status`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListMemberFamily: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/family_master_list_members_ver2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkChangeSim4G: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_change_sim_req_check`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  registerChangeSim4G: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_change_sim_accepted`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkMultiSimCondition: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/multisim_query`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  registerMultisim: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/multisim_reg`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  unRegMultiSim: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/multisim_unreg`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  unLinkMultiSim: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/multisim_unlink`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkSimEzcomCondition: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_check_ezsim`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  changeSimEzcom: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_change_sim_ezcom`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkOtpRechargeRemain: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_payment_recharge_check_remain`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  mobilePaymentRecharge: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_payment_recharge_v2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListPackageCCBS: function (successCallback, failCallback) {
    const URL = `${baseURL}/mobile_home_combo_package_ccbs_list`;
    return postRequest(URL, {}, {}, successCallback, failCallback, transformCCBS);
  },

  getListFiberInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/fiber_search_info2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  registerHomeComboFromFiber: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_home_combo_ccbs_reg`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  mobileAddAccount: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_add_account`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  phoneAddAccount: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/phone_add_account`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  mobileRemoveAccount: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/cust_remove_account`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListRequest: function (successCallback, failCallback) {
    const URL = `${baseURL}/custservice_get_frequently_errors_all`;
    return postRequest(URL, {}, {}, successCallback, failCallback);
  },

  sendTrouble: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/custservice_send_trouble`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  // getListSendTrouble: function (data, successCallback, failCallback) {
  //   const URL = `${baseURL}/custservice_get_sent_trouble`;
  //   return postRequest(URL, data, {}, successCallback, failCallback);
  // },
  getListSendTrouble: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/custservice_get_sent_trouble_v2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getPackageSearch: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/package_search`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getNewsSearch: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/news_search`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getNewsDetail: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_news_detail`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getNewsList: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/help_news_group`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getMyStaffList: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_staff_list_ccos`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getStaffListCate: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_staff_list_category`;
    return postRequest(URL, data, {}, successCallback, failCallback, transformStaffList);
  },

  sendReflectQuality: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_staff_post_ccos`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  rateReflectQuality: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_staff_update_vote`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getEkycToken: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_get_ekyc_token`;
    return postRequestNoLoading(URL, data, {}, successCallback, failCallback, transformEkycToken);
  },

  checkStatusUpdateInfo: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_update_info_check_status`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkOtpIdentification: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_identification_check_otp`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  checkOtpVerifyTTTB: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_identification_log`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  sendSupportLog: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_send_support_log`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  myvnptCheckOwner: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_check_chinhchu`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  ekycIdentificationV2: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/ekyc_identification_ver2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  updateIdentification: function (data, successCallback, failCallback) {
    const config = {
      headers: {
        'Content-Type': "multipart/form-data",
        upload: true
      }
    }
    const URL = `${baseURL}/myvnpt_identification`;
    return postRequest(URL, data, config, successCallback, failCallback);
  },

  updateIdentificationV3: function (data, successCallback, failCallback) {
    const config = {
      headers: {
        'Content-Type': "multipart/form-data",
        upload: true
      }
    }
    const URL = `${baseURL}/myvnpt_identification_v3`;
    return postRequest(URL, data, config, successCallback, failCallback);
  },

  //Lay thong tin thong bao cuoc
  getListBillCode: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_ttc_list_billcode`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  updateListBillCode: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_ttc_billcode_update_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getBillCodeDetail: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_ttc_billcode_detail`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getListPaymentCode: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_ttc_payment_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  sendOtpEmail: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/otp_send_mail`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getPDFTBC: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_get_tbc_file`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getHDDT: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_einvoice_list_by_cust`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getDetailHDDT: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_einvoice_get_file`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  downloadDetailHDDT: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_einvoice_download_file`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  mobileBalanceInfoV2: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/mobile_balance_info_v2`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  myvnptGetQRCode: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_get_qrcode`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  myvnptGetBillCode: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_get_bill_code`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  myvnptSurveyCSKHDate: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_survey_cskh_date`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getStatusTTTB: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_update_info_check_status`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  getPolicyTTTB: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_update_info_popup`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },

  addContactUpdateUserInfor: function (data, successCallback, failCallback) {
    const URL = `${baseURL}/myvnpt_add_contact_update_user_info`;
    return postRequest(URL, data, {}, successCallback, failCallback);
  },
}

